/* global window */

import uuid from 'uuid';

import PropTypes from 'prop-types';
import React from 'react';
import { ContextLocalStorageProvider } from './LocalStorageContext';

function exists(store) {
    try {
        const storage = window[store];
        const test = uuid.v4();

        storage.setItem(test, test);
        storage.getItem(test);
        storage.removeItem(test);
        return true;
    }
    catch (e) {
        return false;
    }
}

function parse(store) {
    return store ? new Map(Object.keys(store).map(key => {
        return [key, store[key]];
    })) : new Map();
}

class LocalStorageProvider extends React.Component {
    static propTypes = {
        children: PropTypes.any
    };

    constructor() {
        super();
        this.getItem = this.getItem.bind(this);
        this.setItem = this.setItem.bind(this);
        this.key = this.key.bind(this);
        this.removeItem = this.removeItem.bind(this);
        this.clear = this.clear.bind(this);
        this.exists = exists('localStorage');
        this.localStorage = parse(this.exists ? window.localStorage : {});
    }

    key(index) {
        return Array.from(this.localStorage.keys())[index];
    }

    getItem(key) {
        return this.localStorage.get(key);
    }

    setItem(key, value) {
        if ((typeof key !== 'string' && typeof key !== 'number') || (typeof value !== 'string' && typeof value !== 'number')) {
            return;
        }
        this.localStorage.set(key, value);
        if (this.exists) {
            window.localStorage.setItem(key, `${ value }`);
        }
    }

    removeItem(key) {
        this.localStorage.delete(key);
        if (this.exists) {
            window.localStorage.removeItem(key);
        }
    }

    clear() {
        this.localStorage.clear();
        if (this.exists) {
            window.localStorage.clear();
        }
    }

    render() {
        const value = {
            getItem: this.getItem,
            setItem: this.setItem,
            key: this.key,
            removeItem: this.removeItem,
            clear: this.clear
        };

        return (
            <ContextLocalStorageProvider value={ value }>
                { this.props.children }
            </ContextLocalStorageProvider>
        );
    }
}

export default LocalStorageProvider;
